<template>
  <div>
    <div class="bannerBox">
      <a-carousel :dot-position="bottom">
        <div>
          <!-- <img class="bannerImg" src="../img/announcement.jpg" /> -->
        </div>
      </a-carousel>
    </div>
    <div style="width: 100%;background-color: #fff;">
      <div class="breadBox">
        <a-breadcrumb>
          <span>
            <img src="@/assets/img/position.png" />
            当前位置：
          </span>
          <a-breadcrumb-item @click="$router.push({ path: '/knowledge/index'})">首页</a-breadcrumb-item>
          <a-breadcrumb-item>{{ title }}</a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="tabBox">
        <div class="activityContent">
          <div class="activityLi" v-for="item in activityData" :key="item.key" @click="onActivity(item.id)">
            <div class="activityImg">
              <img style="width: 100%;height: 100%;" :src="getImg(item.logo)" />
            </div>
            <div class="activityInfoTitle">
              {{ item.title }}
            </div>
            <div class="activityInfoTime">
              时间：{{ item.startDate }}~{{ item.endDate }}
            </div>
            <div class="activityInfoAddress">
              地址：{{ item.address }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { FieldTimeOutlined } from '@ant-design/icons-vue';
import { activity} from "@/api/innovationService";
import { file_service } from "@/api/adminService";


const pagination = {
  pageSize: 8,
  showQuickJumper: true,
};
export default {
  name: 'consultation',
  components: {
    // FieldTimeOutlined,
  },
  mounted() {
    this.getSignup()
    this.title = this.$route.query.type,
        this.activeKey = this.$route.query.activeKey
  },
  data() {
    return {
      pagination,
      noticeData: [],
      policyData: [],
      activityData: [],
      title: '',
        activeKey:"2"
    }
  },
  methods: {
    getSignup() {
      this.getAction({
        url: activity.pageList,
        params: {
          systemType: "knowledge"
        }
      }).then(res => {
        this.activityData = res.records
      })

    },
    //活动详情
    onActivity(id) {
      this.$router.push({
        path: "/finance/activery/Detail",
        query: { id: id ,type:"路演详情"}
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
  }
}
</script>
<style scoped lang="less">
.bannerBox {
  position: relative;
  width: 100%;
  //margin-bottom: 20px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }

  .showMoreButton {
    position: absolute;
    top: 55%;
    left: 21.5%;
    width: 170px;
    height: 56px;
    text-align: center;
    line-height: 56px;
    background-color: #0048c4;
    color: #fff;
    cursor: pointer;
  }
}

.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.tabBox {
  width: 1200px;
  margin: 0 auto;
  padding: 10px 0 20px 0;

  .listBox {
    overflow: hidden;
    padding: 10px 0;
    cursor: pointer;

    .leftBox {
      float: left;
      width: 24%;
      height: 170px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .right {
      float: left;
      margin-left: 2%;
      width: 74%;
      font-size: 14px;

      .title {
        padding: 10px 0;
        font-size: 20px;
        color: #333;
        font-weight: 500;
      }

      .content {
        overflow: hidden;
        margin: 10px 0;
        color: #666;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      .time {
        padding: 10px 0;
        color: #999;
      }
    }
  }

  :deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab) {
    font-size: 14px;
  }

  :deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active) {
    color: #fff;
    background-color: #1890ff;
  }

  .activityContent {

    .activityLi {
      float: left;
      width: 288px;
      margin: 16px 0;
      margin-right:16px;
      cursor: pointer;
      &:nth-child(4n){
        margin-right: 0;
      }

      .activityImg {
        width: 100%;
        height: 180px;
      }

      .activityInfoTitle {
        padding: 15px 10px;
        font-size: 16px;
        color: #333;
      }

      .activityInfoTime {
        overflow: hidden;
        padding: 5px 10px;
        font-size: 14px;
        color: #666;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }

      .activityInfoAddress {
        overflow: hidden;
        padding: 5px 10px 20px 10px;
        font-size: 14px;
        color: #666;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }

    .activityLi:hover {
      //box-shadow: 5px 5px 10px 10px #f1f1f1;
      //transition: all 0.5s ease 0s;

      -webkit-transition: all 0.3s ease 0s;
      transition: all 0.3s ease 0s;
      //border: 1px solid #ffffff;
      cursor: pointer;
      -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
      box-shadow: 0 5px 10px 1px #d2e6ff;
      //.activityInfoTitle {
      //	color: #fff;
      //	background-color: #2162e4;
      //
      //}
      //
      //.activityInfoTime {
      //	color: #fff;
      //	background-color: #2162e4;
      //}
      //
      //.activityInfoAddress {
      //	color: #fff;
      //	background-color: #2162e4;
      //}
    }
  }
}
</style>
